import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Kuzzle, WebSocket } from 'kuzzle-sdk'
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CommonService {

  host:{port:string,hostname:string, origin?:string};
  kuzzle:any;
  kuzzleHeader:any;

  constructor(private httpClient: HttpClient,@Inject('apiEndPoint') private apiEndPoint: string,private toast:ToastrService, @Inject('fileServerUrl') private fileServerUrl: string,) { 

    let options:{ssl:boolean, timeout:number, pingInterval:number, reconnectionDelay:number,autoReconnect:boolean, port?:number} = {
    ssl: true,
    timeout:0,
    pingInterval:5000,
    reconnectionDelay:500,
    autoReconnect:true                  
  };

  let wsurl="";
  try{
      this.host = new URL(this.apiEndPoint)
     
      if(+this.host?.port){
        wsurl = `${this.host?.hostname}`;
             options["port"] = +this.host?.port;
      }else{
        wsurl = `${this.host?.hostname}/wsurl`
      }
     
  }catch(err){
     const hostnameRegex = /^(https|http)?:\/\/([^:\/]+)/i;
     let url = window.location.href;
     const match = url.match(hostnameRegex);
     console.log(match);
     this.host = {hostname:match?.[2], port:''};
     wsurl = `${this.host?.hostname}/wsurl`
  } 
  console.log(this.host); 


   this.kuzzle = new Kuzzle(new WebSocket(`${wsurl}`, options))           //for realtime subscription
   this.kuzzleHeader = new Kuzzle(new WebSocket(`${wsurl}`, options));
  }
  reroutingSubject:BehaviorSubject<any> = new BehaviorSubject({})
  // host:{port:string,hostname:string} = new URL(this.apiEndPoint)||{hostname:this.hostname, port:''};
  testViewTypeSubject:Subject<any> = new Subject();
  statusApiSubscription:any={};
  statusSubject:Subject<any> = new Subject();
  reloadData:BehaviorSubject<any> = new BehaviorSubject({});



    //creating this so that we do not connect to the same kuzzle twice or disconnect somewhere else

  getData(id) {
    return this.httpClient.post((this.apiEndPoint + 'getUserNetworkDetails'), id);
  }
  updateDataById(id) {
    return this.httpClient.get((this.apiEndPoint + 'getUserNetworkDetails/' + id));
  }
  deleteDataById(params) {
    return this.httpClient.post((this.apiEndPoint + 'deleteAgreement'), params);
  }

  getoNAList() {
    const body = {
      "query": {
        "bool": {
          "must": [
            { "query_string": { "query": false, "type": "phrase", "fields": ["soft_delete"] } }
          ]
        }
      }, "sort": { "_kuzzle_info.createdAt": "desc" }
    }
    return this.httpClient.post(this.apiEndPoint + '/gwdevice/edgedevice_helper/_search?size=10000', body);
  }

  // Filters a device list against the mappedDevices object (keyed by xedge id, with a `platform`
  // serial and an `identifiers` list of modem IMEIs per device). An empty mappedDevices means
  // "no filter applied" — used until the real mapping API is wired up.
  filterDevicesByMapping(devices: any[], mappedDevices: any, idFields: string[] = ['id', 'deviceid', 'serial', 'xedge_serialno']): any[] {
    if (!mappedDevices || Object.keys(mappedDevices).length === 0) {
      return devices || [];
    }
    return (devices || []).filter((device: any) => {
      const matchesId = idFields.some(field => device?.[field] && mappedDevices[device[field]]);
      const matchesPlatform = !matchesId && device?.platform_serialno &&
        Object.values(mappedDevices).some((mapped: any) => mapped?.platform === device.platform_serialno);
      return matchesId || matchesPlatform;
    });
  }

  // Filters an IMEI/identifier-based list (e.g. modem dropdowns showing IMEI instead of serial)
  // against the union of every mapped device's `identifiers`. Empty mappedDevices = no filter.
  filterIdentifiersByMapping(items: any[], mappedDevices: any, identifierField: string = 'imei'): any[] {
    if (!mappedDevices || Object.keys(mappedDevices).length === 0) {
      return items || [];
    }
    const allowedIdentifiers = new Set<string>();
    Object.values(mappedDevices).forEach((device: any) => {
      (device?.identifiers || []).forEach((identifier: string) => allowedIdentifiers.add(identifier));
    });
    return (items || []).filter((item: any) => allowedIdentifiers.has(item?.[identifierField]));
  }

  cancelAllSebscriptions(){
    //this will be triggered when ngOnDestroy is called in a component so that checkStatus will stop coming;
       for(let each in this.statusApiSubscription){
                delete this.statusApiSubscription[each];
       }
  }

  getDevicereqStatus(rule: any) {
    const payload = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: rule,
                type: "phrase",
                fields: ["rule_id"],
              },
            },
          ],
        },
      },
      sort: [{ "_kuzzle_info.createdAt": "desc" }],
    }
    return this.httpClient.post(this.apiEndPoint + '/gwdevice/devicereq/_search?size=1', payload);
  }
  

  checkStatus(ruleid:any, interval:any, timeout:any, rule:any){
    const statusIntervals = {};
    statusIntervals[ruleid]={};
    statusIntervals[ruleid]['time']=new Date().valueOf();
      this.statusApiSubscription[ruleid]=true;
      this.getDevicereqStatus(ruleid).subscribe((response:any)=>{
           this.handleResponse(response,rule, ruleid,timeout,statusIntervals);
       })
     return this.statusSubject;
   }

   handleResponse(response, rule, ruleid,timeout, statusIntervals){
    this.statusSubject.next(response?.result?.hits?.[0]?._source?.status);
    if(response?.result?.hits?.[0]?._source?.status=="active"){
      this.handleActive(this.generateMessages(rule, "active"), ruleid, timeout,rule, statusIntervals);
      }
      else if(response?.result?.hits?.[0]?._source?.status=="In Progress"){
       this.handleInprogress(this.generateMessages(rule, "inprogress"), ruleid, timeout,rule, statusIntervals);
     }
      else if(response?.result?.hits?.[0]?._source?.status=="Not Applied"){
        this.handleNotApplied(this.generateMessages(rule, "notapplied"), ruleid,statusIntervals);
      }
      else if(response?.result?.hits?.[0]?._source?.status=="Applied"){
        this.handleSuccess(this.generateMessages(rule, "applied"), ruleid, statusIntervals);
      }
      else if(response?.result?.hits?.[0]?._source?.status=="Rejected"){
        this.handleReject(this.generateMessages(rule, "rejected"), ruleid,statusIntervals);
      }
   }
 
   handleSuccess(message:string, ruleid:string,intervalMAp:any){
           this.toast.success(message);
          }
 
   handleRejected(message:string, ruleid:string, intervalMAp:any){
           this.toast.warning(message);
          }
 
   handleTimeout(message:string, ruleid:string,intervalMAp:any){
           this.toast.warning(message);
          }
 
   handleActive(message:string, ruleid:string,timeout:any,rule:any, intervalMAp:any){
           if(new Date().valueOf()-intervalMAp?.[ruleid]?.time>timeout){
             this.handleTimeout(this.generateMessages(rule, "timeout"), ruleid,intervalMAp);
                       }else{
                        if(this.statusApiSubscription?.[ruleid]){
                          this.toast.info(message);
                          let out = setTimeout(()=>{
                            clearTimeout(out);
                            this.getDevicereqStatus(ruleid).subscribe((response:any)=>{
                              this.handleResponse(response,rule, ruleid,timeout,intervalMAp);
                             })
                          },4000)
                        }
                       }
        }

  handleInprogress(message:string, ruleid:string,timeout:any,rule:any, intervalMAp:any){
  
    if(new Date().valueOf()-intervalMAp?.[ruleid]?.time>timeout){
      this.handleTimeout(this.generateMessages(rule, "timeout"), ruleid,intervalMAp);
                }else{
                  console.log(this.statusApiSubscription?.[ruleid], ruleid, "is the status");
                  if(this.statusApiSubscription?.[ruleid]){
                    this.toast.info(message);
                    let out = setTimeout(()=>{
                      clearTimeout(out);
                      this.getDevicereqStatus(ruleid).subscribe((response:any)=>{
                        this.handleResponse(response,rule, ruleid,timeout,intervalMAp);
                       })
                    },4000)
                  }
      
                }
  }
 
   handleNotApplied(message:string, ruleid:string,intervalMAp:any){
             this.toast.warning(message);
            }

   handleReject(message:string, ruleid:string,intervalMAp:any){
          this.toast.error(message);
    }

 
 
   generateMessages(rule:any, type:any, additionalmessage?:any){
     switch(rule){
           case "gps_setting":
             return type=="applied"?`Default GPS applied successfully ${additionalmessage?additionalmessage:''}`:
                    type=="rejected"?`Request for default GPS rejected by device ${additionalmessage?additionalmessage:''}`:
                    type=="notapplied"?`Request for Default gps not applied ${additionalmessage?additionalmessage:''}`:
                    type=="active"?`Waiting for device to respond ${additionalmessage?additionalmessage:''}`:
                    type=="timeout"?`Default GPD request timed out ${additionalmessage?additionalmessage:''}`:
                    type=="inprogress"?`Setting up default GPS is in progress ${additionalmessage?additionalmessage:''}`:undefined;
            case "device_debug_reboot":
              return type=="applied"?`Device is going to reboot ${additionalmessage?additionalmessage:''}`:
                    type=="rejected"?`Request rejected by device ${additionalmessage?additionalmessage:''}`:
                    type=="notapplied"?`Request not applied ${additionalmessage?additionalmessage:''}`:
                    type=="active"?`Waiting for device to respond ${additionalmessage?additionalmessage:''}`:
                    type=="timeout"?`Request timed out ${additionalmessage?additionalmessage:''}`:
                    type=="inprogress"?`Request is in progress ${additionalmessage?additionalmessage:''}`:undefined;
            case "device_debug_url":
              return type=="applied"?`Url changed successfully${additionalmessage?additionalmessage:''}`:
                    type=="rejected"?`Url change request rejected by device ${additionalmessage?additionalmessage:''}`:
                    type=="notapplied"?`Url change request not applied ${additionalmessage?additionalmessage:''}`:
                    type=="active"?`Waiting for device to respond ${additionalmessage?additionalmessage:''}`:
                    type=="timeout"?`Request timed out. ${additionalmessage?additionalmessage:''}`:
                    type=="inprogress"?`Url change request is in progress. ${additionalmessage?additionalmessage:''}`:undefined;
 
     }
   }
 
   clearAllStatusIntervals(intervalMap:any){
     if(intervalMap){
       for(let each in intervalMap){
           intervalMap?.[each]?.interval&&clearInterval(intervalMap?.[each]?.interval);
           delete intervalMap?.[each]?.interval;
       }
     }
   }

   simulateToasts(status="Applied", rule:any){
    let stat = status=="Applied"?"868371051634463_device_debug_1729856113689":
               status=="Rejected"?"XEDG0011040083_device_debug_1729590888003":
               status=="In Progress"?"XEDG0011040083_device_debug_1729592439606":
               status=="active"?"WMTK0014830041_device_debug_1729757595219":undefined;
               this.checkStatus(stat, 2000,30000, rule).subscribe((status)=>{})

  }

  getLedStatus(){
    return this.httpClient.get(this.apiEndPoint + '/gwdevice/configparam/led_status');
  }

 LEDState:any ={
  "LED":{  //this is modem level LED status
              OFF_OFF_SOLID: "Starlight (XEDGE application) is booting up",
              OFF_OFF_OFF: "Empty Slot or No Modem is detected on the Slot",
              OFF_SOLID_SOLID: "Modem Admin Status Down",
              OFF_BLINKING_BLINKING: "Modem Admin Status is Maintenance",
              OFF_SOLID_OFF: "Telemetry is in progress. When Modem has SIM",
              OFF_BLINKING_OFF: "RF Walk test is in progress, When Modem has SIM",
              BLINKING_OFF_OFF: "IPERF Test is in Progress",
              SOLID_OFF_OFF: "On Management Modem",
              SOLID_SOLID_OFF: "On Management modem and Telemetry is in progress",
              BLINKING_BLINKING_BLINKING: "No test is running, When Modem has SIM",
              OFF_SOLID_BLINKING: "Modem does not have SIM, Telemetry running",
              OFF_BLINKING_SOLID: "Modem does not have SIM and Walk test is running"
  },
  "Power LED":{
              BLINKING_OFF_OFF :"Starlight (XEDGE application) is booting up",
              OFF_SOLID_SOLID :"Device has controller connectivity and in Admin Down State",
              OFF_BLINKING_BLINKING :"Device has controller connectivity and in Admin Maintenance State",
              OFF_SOLID_OFF: "Device has controller connectivity and in Admin Up State"
  },
  "Data LED":{
              OFF_OFF_SOLID: "No Controller connectivity is established",
              SOLID_OFF_OFF: "Controller connectivity is through management modem",
              OFF_SOLID_OFF: "Controller connectivity is through WiFi/LAN"
  }
 }
 
    getDeviceStatus(id): Observable<any> {
        let headers = new HttpHeaders();
        return this.httpClient.get(this.apiEndPoint + '/gwdevice/edgedevicemaster_slice/' + id, { headers });
    }
 getBandLockTempaltes(deviceid): Observable<any> {
  const match =[];
  if(deviceid){
    match.push({ "match": { "devices.deviceid": deviceid }})
  }
 
      const filter = {
        "query": {
          "nested": {
            "path": "devices",
            "query": {
              "bool": {
                "must": match
              }
            }
          }
        }
      }
      return this.httpClient.post(`${this.apiEndPoint}/gwdevice/devicegroup/_search?size=10`,filter)
    } 


   getDeviceLogs(deviceid:any, starttime:any, endtime:any): Observable<any> {
      const filter = {deviceid, starttime, endtime};
      return this.httpClient.post(`${this.fileServerUrl}/binary_files/structured`,filter)
    } 


   downloadLogs(filename:any): Observable<any> {
      return this.httpClient.get(`${this.fileServerUrl}/custom/binaries/${filename}`,{responseType: 'blob',reportProgress:true,observe:'events'})
    }
    
  getDevicereqRuleStatus(rule: any, deviceid?:any) {
    const payload =  {
    "query": {
        "bool": {
            "must": [
                {
                    "query_string": {
                        "query": deviceid,
                        "type": "phrase",
                        "fields": [
                            "deviceid"
                        ]
                    }
                },
                {
                    "query_string": {
                        "query": rule,
                        "type": "phrase",
                        "fields": [
                            "rule"
                        ]
                    }
                },
                {
                    "query_string": {
                        "query": "Applied",
                        "type": "phrase",
                        "fields": [
                            "status"
                        ]
                    }
                }
            ],
            "must_not": [
                {
                    "query_string": {
                        "query": "Not Applied",
                        "type": "phrase",
                        "fields": [
                            "status"
                        ]
                    }
                }
            ]
        }
    },
    "aggregations": {
        "modems": {
            "terms": {
                "field": "imei",
                "size": 4
            },
            "aggregations": {
                "last_5_records": {
                    "top_hits": {
                        "sort": [
                            {
                                "_kuzzle_info.createdAt": {
                                    "order": "desc"
                                }
                            }
                        ],
                        "size": 5
                    }
                }
            }
        }
    },
    "size": 0
}
    return this.httpClient.post(this.apiEndPoint + '/gwdevice/devicereq/_search?size=1', payload);
  }

   getCurrentKuzzleTime() {
    return this.httpClient.get(`${this.apiEndPoint}/_now`)
  }

  trigger(parameters) {
    return this.httpClient.post(
      `${this.apiEndPoint}/_/2.0/edgecontrol`,
      parameters
    );
  }

  stopAllTestWithRules(ruleid: any[] = []) {
    return this.httpClient.post(`${this.apiEndPoint}/_/2.0/edgecmdstop`, {
      ruleids: ruleid,
    });
  }
  
} 
